module.exports = __webpack_public_path__ + "static/img/waiting.e3f1bfcd.png";